import Modal from 'components/shared/Modal';
import ReactModal from 'react-modal';
import { useChangePasswordConfirmModal } from './ChangePasswordConfirmModal.hooks';
import { ChangePasswordConfirmModalProps } from './ChangePasswordConfirmModal.types';
import { ChangePasswordRequestNotSent } from './components/ChangePasswordRequestNotSent';
import { ChangePasswordRequestSent } from './components/ChangePasswordRequestSent';

export const ChangePasswordConfirmModal: React.FC<
  ChangePasswordConfirmModalProps
> = ({ isOpen, close, manfrediteEmail }) => {
  const { isPasswordChangeRequestSent, sendChangePasswordRequest } =
    useChangePasswordConfirmModal(manfrediteEmail, isOpen);

  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnOverlayClick={true}
      onRequestClose={close}
    >
      <Modal onClose={close}>
        {!isPasswordChangeRequestSent ? (
          <ChangePasswordRequestNotSent
            onAccept={sendChangePasswordRequest}
            onCancel={close}
          />
        ) : (
          <ChangePasswordRequestSent
            onAccept={close}
            manfrediteEmail={manfrediteEmail}
          />
        )}
      </Modal>
    </ReactModal>
  );
};
